import * as confidentialAction from './confidential-action'

export {
  confidentialAction,
}



// WEBPACK FOOTER //
// ./src/actions/confidential/index.js